/* unplugin-vue-components disabled */import { render } from "./sourcematerial.vue?vue&type=template&id=57878110&scoped=true"
import script from "./sourcematerial.vue?vue&type=script&lang=js"
export * from "./sourcematerial.vue?vue&type=script&lang=js"

import "./sourcematerial.vue?vue&type=style&index=0&id=57878110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57878110"]])

export default __exports__